import { useSelector } from 'react-redux';
import { selectAuthStatus } from '../../../app/store/authSelectors';

export const useAuthStatus = () => {
  const status = useSelector(selectAuthStatus);
  
  return {
    isLoading: status === 'loading',
    isAuthenticated: status === 'succeeded',
    isError: status === 'failed'
  };
};
